import React from "react";
import { LoaderCircle, Pencil } from "lucide-react";

const EntityInformationModal = ({
    show,
    onHide,
    title,
    children,
    onEdit,
    isEditing = false,
    editTitle = "Edit",
}) => {
    if (!show) return null;

    return (
        <div className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50">
            <div className="tw-bg-white tw-rounded-xl tw-shadow-xl tw-max-w-lg tw-w-full tw-p-6 tw-relative">
                <button
                    className="tw-absolute tw-top-2 tw-right-2 tw-text-gray-500 hover:tw-text-black tw-text-2xl tw-leading-none"
                    onClick={onHide}
                >
                    &times;
                </button>
                <h3 className="tw-text-lg tw-font-bold tw-mb-2 tw-flex tw-justify-between tw-items-center">
                    <span>{title}</span>
                    {onEdit && (
                        <button
                            className="tw-text-blue-600 hover:tw-text-blue-800 tw-ml-2"
                            onClick={onEdit}
                            title={editTitle}
                        >
                            {isEditing ? (
                                <LoaderCircle className="tw-h-4 tw-w-4 tw-animate-spin" />
                            ) : (
                                <Pencil className="tw-h-4 tw-w-4" />
                            )}
                        </button>
                    )}
                </h3>

                <hr className="tw-border tw-border-solid tw-border-black" />

                <div className="tw-text-sm tw-mt-3">{children}</div>
            </div>
        </div>
    );
};

export default EntityInformationModal;
